/* Publish by EComposer at 2026-09-25 21:18:29*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-277u18jts45"]=  window.__ectimmers["ecom-277u18jts45"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-277u18jts45').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-277u18jts45', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rqwcn96agyc"]=  window.__ectimmers["ecom-rqwcn96agyc"] || {};
if(!this.$el)return!1;const t=this.$el,e=this,i=this.settings.animation,n=new CustomEvent("animation",function(){});let o=t.querySelector(".ecom__heading");o.querySelector("a")&&(o=o.querySelector("a")),o.addEventListener("animation",()=>{s()}),o.addEventListener("blur",function(r){r.target.dispatchEvent(n)});function s(){if(i==="typing"){let r=function(){setTimeout(function(){var b;let _=(b=g.settings)==null?void 0:b.animation;if(a.innerText=l[m].slice(0,c),d)if(c>l[m].length){d=!1,_=="typing"&&setTimeout(function(){r()},2e3);return}else c++;else c===0?(d=!0,m=(m+1)%l.length):c--;r()},d?120:60)},a=t.querySelector(".highlight-animation--typing");if(!a)return!1;let l=a.dataset.heading.split("|")||"",c=0,d=!0,m=0;const g=e;r()}if(i==="smooth"){let r=function(){let l=0,c= window.__ectimmers["ecom-rqwcn96agyc"]["tsfyxts1b"] = setInterval(function(){i!="smooth"&&clearInterval(c),l++,a.forEach((d,m)=>{l==a.length&&(l=0),m==l?d.classList.add("is-active"):d.classList.remove("is-active")})},3e3)},a=t.querySelectorAll(".heading-animation--smooth-item");if(!a)return!1;r()}}s()

                    });
                    
                        document.querySelectorAll('.ecom-rqwcn96agyc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rqwcn96agyc', settings: {"animation":"smooth"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b9dbhu5kxml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b9dbhu5kxml', settings: {"animation":"smooth"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmyd3liseq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmyd3liseq', settings: {"animation":"smooth"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mpqxi0vcj69').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mpqxi0vcj69', settings: {"animation":"smooth"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-y7qftbkosw"]=  window.__ectimmers["ecom-y7qftbkosw"] || {};
if(!this.$el)return;const t=this.$el;if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelectorAll("[ecom-modal]");e.length&&new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}if(this.settings.link!=="lightbox"&&this.settings.link!=="custom"&&/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){let i=t.querySelector(".ecom-image-picture-hover"),n=t.querySelector(".ecom-image-picture.ecom-image-has-hover");if(!i||!n)return;i.addEventListener("click",function(){n.classList.add("image-active"),i.classList.add("image-hidden")}),n.addEventListener("click",function(){n.classList.remove("image-active"),i.classList.remove("image-hidden")})}

                    });
                    
                        document.querySelectorAll('.ecom-y7qftbkosw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y7qftbkosw', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ypp8y93a3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ypp8y93a3h', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m2kew73cm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m2kew73cm', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6kijs7wz5gh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6kijs7wz5gh', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}